<template lang="pug">
  div.weaponList
    van-grid(:column-num="3", :center="false")
      van-grid-item(v-for="item in weaponItemList", @click="showWeaponContent(item)")
        div.weaponClassIcon
          img(alt="", v-lazy="require('../assets/weapon_class_icon/'+item.weaponClassIcon)")
        div.weaponItem
          img(alt="", v-lazy="require('../assets/weapon_icon/'+item.weaponIcon)")
</template>

<script>
export default {
  name: 'WeaponList',
  data() {
    return {
      weaponItemList:[]
    }
  },
  created() {
    
  },
  methods:{
    showWeaponContent(item) {
      this.$router.push({
          path: "/weapon/content/"+item.weaponId
      })
    }
  },
  components:{

  },
  mounted() {
    let wikiData = require("../assets/lang/zh_CN.json")
    this.$nextTick(() => {
      this.weaponItemList = wikiData.weaponItemList
    })
  }
}
</script>

<style lang="scss">
.weaponList {
  .van-grid-item__content {
    padding: 0px;
    min-width: 114px;
    height: 140px;
    background: url("../assets/weapon_list_icon_bg.png") no-repeat;
    background-size: contain;
  }
  .van-hairline--top::after {
    border-top-width: 0px;
  }
  .van-grid-item__content::after{
    border-width: 0px;
  }
  .van-grid-item {
    padding: 10px 0;
    justify-content: center;
    display: flex;
  }
  .weaponClassIcon {
    padding: 8.82px 0 0 19.76px;
    width: 18px;
    height: 26px;
  }
  .weaponClassIcon img {
    width: 100%;
    height: 100%;
  }
  .weaponItem {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 68px;
    height: 91px;
  }
  .weaponItem img {
    width: 100%;
    height: 100%;
  }
}
</style>